// extracted by mini-css-extract-plugin
export default {"dateAndIsSampleTemplateWrapper":"DescriptionContent_dateAndIsSampleTemplateWrapper__5Q5HG"};